import { ResourceLoader, Dimension, toSquareAngle } from './imagepdfviewer.model';
import { ImagePdfViewerConfig } from './imagepdfviewer.config';

export class ImageResourceLoader extends ResourceLoader {

  setUp() {
    this.loadResource();
  }

  loadResource() {
    this.loading = true;
    this._image = new Image();
    this._image.addEventListener('load', (evt: any) => {
      this.loaded = true;
      this.loading = false;
      this.resourceChange.next(evt);
    }, false);
    this._image.src = this.src;
  }
}
